import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    cursor: 'pointer',
  },
  checked: {
    backgroundColor: theme.palette.background.default,
    borderColor: '#3C99F4',
    borderWidth: '.15em',
  },
  noBorder: {
    border: '0px !important',
  },
  content: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))

export default styles
